
import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

window.addEventListener('frame-ready', init)

function init() {

    const hero = document.querySelector('.title-hero-thin-image')

    if(hero) {
        const overlay = hero.querySelector('.overlay-wrapper')
        const title = hero.querySelector('h1')
        const logo = hero.querySelector('.brand-avatar')

        gsap.timeline()
        .to([overlay, title, logo], { opacity: 1, stagger: .15 })
    }
}
